import React from "react";
import { BsTwitter, BsLinkedin } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://www.linkedin.com/in/akramul-r-738977141/">
          <BsLinkedin />
        </a>
      </div>

      <div>
        <a href="https://twitter.com/akramul_ratul">
          <BsTwitter />
        </a>
      </div>

      <div>
        <a href="https://www.facebook.com/akramul.ratul/">
          <FaFacebookF />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
